import { ProjectTypes } from '@platform/types';
import React, { useEffect, useRef, useState } from 'react';
import Survey from './index';

interface Props {
  workingLayer: ProjectTypes.SocialExplorerWorkingLayer;
}

const SurveyAnalysis: React.FC<Props> = ({ workingLayer }) => {
  const { featureSelection, variableSelection, metadata } = workingLayer;
  const { surveyName, datasetAbbreviation, isUserSurvey } = metadata;
  const selectionChangeTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // IMPORTANT: this local state buffers the outer selection events which might occur too often
  const [featuresForAnalysis, setFeaturesForAnalysis] = useState<ProjectTypes.WorkingLayerFeatureSelection[]>([
    ...featureSelection,
  ]);

  useEffect(() => {
    clearTimeout(selectionChangeTimeoutRef.current as NodeJS.Timeout);

    selectionChangeTimeoutRef.current = setTimeout(() => {
      setFeaturesForAnalysis(featureSelection);
    }, 200);
  }, [featureSelection]);

  const surveyFeatures: ProjectTypes.GeoFeatureSelection[] = featuresForAnalysis.map((f) => ({
    fips: f.id.toString(),
    label: f.name,
    summaryLevelId: (f.metadata as any).summaryLevelId, // TODO: some TS needed
  }));

  const surveyVariableSelection: ProjectTypes.VariableSelection[] = variableSelection.map((v) => ({
    surveyName,
    isUserSurvey,
    tableGuid: v.tableId,
    datasetAbbrev: datasetAbbreviation,
    variableGuid: v.variableId,
    universeVariableUuid: undefined,
  }));

  return (
    <div className="flex flex-col gap-2 pb-4">
      <div className="font-semibold">{workingLayer.description}</div>
      {featuresForAnalysis.length === 0 && <span className="text-gray-400">No matching geographies</span>}
      {featuresForAnalysis.length > 0 && (
        <Survey features={surveyFeatures} variableSelection={surveyVariableSelection} />
      )}
    </div>
  );
};

export default SurveyAnalysis;
